export default {
  "content": "<path d=\"M13 18.086l2.793-2.793 1.414 1.414-4.5 4.5a1 1 0 01-1.414 0l-4.5-4.5 1.414-1.414L11 18.086V10h2v8.086z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 5.5a1 1 0 011 1v12a1 1 0 01-1 1h-2.75v-2h1.75v-6.532A4 4 0 0117.032 7.5H6.968A4 4 0 013.5 10.968V17.5h1.75v2H2.5a1 1 0 01-1-1v-12a1 1 0 011-1h19zm-18 3.434A1.998 1.998 0 004.935 7.5H3.5v1.434zM19.065 7.5A1.998 1.998 0 0020.5 8.934V7.5h-1.435z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};